export default __webpack_public_path__ + "static/media/logo-chander131.d9150736.png";